/**
 * Copyright 2013-2017 Zegeba AS (814 777 812 MVA), Ålesund, Norway
 *                     www.zegeba.com - contact@zegeba.com
 *
 * All rights reserved. You may not use or distribute the content of this file
 * in part or as a whole without explicit written consent from Zegeba AS.
 *
 * This software/the content of this file is distributed AS IS, WITHOUT WARRANTIES OF ANY KIND.
 * Zegeba AS or the authors of the software accepts NO LEGAL LIABILITY OR RESPONSIBILITY for any
 * loss due to the use of the software/content of this file.
 *
 */
import Vue from "vue";
import Router from "vue-router";
import login from "@/components/views/Login";
import status from "@/components/views/Status";
import serverStatusInfo from "@/components/views/ServerStatusInfo";
import usersSection from "@/components/views/UsersSection";
import resetPassword from "@/components/views/ResetPassword";
import createUpdatePassword from "@/components/views/CreateUpdatePassword";
import store from "../store";

Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/login",
			name: "login",
			component: login,
			meta: {
				requiresUnauth: true
			}
		},
		{
			path: "/",
			name: "status",
			component: status,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: "/server-info/:serverName",
			name: "serverInfo",
			component: serverStatusInfo,
			meta: {
				requiresAuth: true,
				title: route => route.params.serverName
			}
		},
		{
			path: "/users",
			name: "users",
			component: usersSection,
			meta: {
				requiresAuth: true,
				title: () => "Users"
			}
		},
		{
			path: "/reset-password",
			name: "resetPassword",
			component: resetPassword,
			meta: {
				requiresUnauth: true
			}
		},
		{
			path: "/password-reset",
			name: "createUpdatePassword",
			component: createUpdatePassword,
			meta: {
				requiresUnauth: true
			}
		},
		{
			path: "/:notFound(.*)",
			redirect: { name: "login" }
		}
	]
});

router.beforeEach((to, _, next) => {
	if(to.meta.title) {
		document.title = "Zegeba Server Status - " + to.meta.title(to);
	}

	if (to.meta.requiresAuth && !localStorage.getItem("access_token")) {
		next({ name: "login" });
	} else if (to.meta.requiresUnauth && (store.getters["session/userIsLoggedIn"] || localStorage.getItem("access_token"))) {
		next({ name: "status" });
	} else {
		next();
	}
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js